import Axios from '../../../utils/axios'
import axios from 'axios'
import { headers } from '../../../utils/token'
import moment from 'moment'

export const loadAccessAuditTrail = (data) => dispatch => {
  return Axios.get('/admin/login-audit-trails', dispatch, 'GET_ACCESS_AUDIT_TRAIL', { headers: headers })
}
